import { render, staticRenderFns } from "./IssuerProfile.vue?vue&type=template&id=d0a91016"
import script from "./IssuerProfile.vue?vue&type=script&lang=js"
export * from "./IssuerProfile.vue?vue&type=script&lang=js"
import style0 from "./IssuerProfile.vue?vue&type=style&index=0&id=d0a91016&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports